/**
 * Safari Slideshow Height Fix
 * Forces slideshow components inside product card galleries
 * to fill their container height — fixing the white strip bug in Safari.
 */

(function () {
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (!isSafari) return; // Only run on Safari

  function fixSlideshowHeights() {
    const galleries = document.querySelectorAll('.card-gallery');

    galleries.forEach((gallery) => {
      const slideshow = gallery.querySelector('slideshow-component');
      if (!slideshow) return;

      // Get the gallery's rendered height
      const galleryHeight = gallery.offsetHeight;
      if (!galleryHeight) return;

      // Force the slideshow component to match
      slideshow.style.setProperty('height', galleryHeight + 'px', 'important');
      slideshow.style.setProperty('width', '100%', 'important');
      slideshow.style.setProperty('display', 'block', 'important');

      // Force all slides inside to match
      const slides = slideshow.querySelectorAll('[ref="slideshow"] > *');
      slides.forEach((slide) => {
        slide.style.setProperty('height', galleryHeight + 'px', 'important');
        slide.style.setProperty('min-height', galleryHeight + 'px', 'important');
      });

      // Force all images inside to fill
      const images = slideshow.querySelectorAll('img');
      images.forEach((img) => {
        img.style.setProperty('width', '100%', 'important');
        img.style.setProperty('height', '100%', 'important');
        img.style.setProperty('object-fit', 'cover', 'important');
        img.style.setProperty('object-position', 'center top', 'important');
        img.style.setProperty('display', 'block', 'important');
      });
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSlideshowHeights);
  } else {
    fixSlideshowHeights();
  }

  // Run again after full page load (images/fonts may shift layout)
  window.addEventListener('load', fixSlideshowHeights);

  // Run on resize in case layout reflows
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fixSlideshowHeights, 150);
  });

  // Watch for dynamically injected cards (e.g. tab switching, infinite scroll)
  const observer = new MutationObserver(function (mutations) {
    const relevant = mutations.some((m) =>
      [...m.addedNodes].some(
        (n) => n.nodeType === 1 && (n.classList?.contains('card-gallery') || n.querySelector?.('.card-gallery'))
      )
    );
    if (relevant) fixSlideshowHeights();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();